import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
      async MarkAWBInvalid(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'GetCargoMarkShipmentInvalid',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
	  async MarkPRQInvalid(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'GetCargoMarkPickupRequestInvalid',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getInvoiceQuantity(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargobooking/getinvoicequantity',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getPendingEWBNSListing(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargobooking/getpendingEWBNlist',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getInvoiceDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargobooking/getinvoicedetails',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async updatePhysicalWeight(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'UpdatecargoPhysicalWeight',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async validateEWB(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargobooking/validateewb',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async updateInvoiceDetailsInManifest(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargobooking/updateInvoiceDetailsInManifest',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getPhysicalWeight(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getVehicleCapacityDetails',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getEbnListingdata(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getExpiryEbnList',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getAppointmentDateDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getappointmentdatedetails',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async UpdateAppointmentDate(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/updateappointmentdate',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getBookingMode(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getBookingmode',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async changeBookingMode(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'changeBookingMode',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getCargoClientDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getCargoClientDetails',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async verifyHSN(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'cargobooking/verifyHSN',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async UpdateCargoClientDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'UpdatecargoClientName',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async PushParentData(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'pushMissingParentdata',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async pendingAWBVerification(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'pendingAWBVerification',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async MarkMPSInvalid(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'markShipmentInvalidOnChildLevel',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getMPSlistdetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getMPSListagainstAwb',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async GetShortMpsDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getshortmpsdetails',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async UpdateShorttMpsDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'updateshortmps',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getSRdetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'gettripdetails',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async updateTripSR(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'updateassignedsr',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getFTCdetailsdata(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getftcshipmentdetailssupport',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async updateFTCCashmemo(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/updateftccashmemo',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getTransactionList(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getairwallettransactions',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getWalletTransationResponse(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getwallettransationresponse',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async airCargoPaymentRevert(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/aircargo/payment/revert',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getUpdateBookingDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargobooking/getviewdetailsforapibooking',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getTSPBAUserlist(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'tspbausers/list',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async saveTSPBAUserDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'tspbausers/savedetails',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
	  
	async getPOPShipment(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getproofofpickup',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async GetAllPOPShipment(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'downloadproofofpickup',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

  async missingPod(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'pod/updatepodurl',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getSRTransferUserDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getsrtransferuserdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/utility/services/utility.service.js